
<template>
  <div class="valid-code-container">
    <canvas
      ref="canvasRef"
      :width="contentWidth"
      :height="contentHeight"
      @click="refreshCode"
      class="cursor-pointer"
    ></canvas>
  </div>
</template>

<script>
export default {
    name: `ValidCode`,
    props: {
        identifyCode: {
            type: String,
            default: ``
        },
        contentWidth: {
            type: Number,
            default: 120
        },
        contentHeight: {
            type: Number,
            default: 40
        },
        fontSizeMin: {
            type: Number,
            default: 20
        },
        fontSizeMax: {
            type: Number,
            default: 30
        }
    },
    data() {
        return {
            currentCode: ``
        }
    },
    watch: {
        identifyCode: {
            immediate: true,
            handler(newVal) {
                if (newVal) {
                    console.log(newVal)
                    this.currentCode = newVal
                    this.$nextTick(() => {
                        this.drawCode()
                    })
                }
            }
        }
    },
    mounted() {
        this.refreshCode()
    },
    methods: {
    // 生成随机数
        randomNum(min, max) {
            return Math.floor(Math.random() * (max - min) + min)
        },

        // 生成随机颜色
        randomColor(min, max) {
            const r = this.randomNum(min, max)
            const g = this.randomNum(min, max)
            const b = this.randomNum(min, max)
            return `rgb(${r},${g},${b})`
        },

        // 刷新验证码
        refreshCode() {
            this.currentCode = this.generateRandomCode(4)
            this.$emit(`update:identifyCode`, this.currentCode)
            this.drawCode()
        },

        // 生成随机验证码
        generateRandomCode(length) {
            const chars = `ABCDEFGHJKMNPQRSTWXYZabcdefghjkmnpqrstwxyz23456789`
            let code = ``
            for (let i = 0; i < length; i++) {
                code += chars[this.randomNum(0, chars.length)]
            }
            return code
        },

        // 绘制验证码
        drawCode() {
            const canvas = this.$refs.canvasRef
            if (!canvas) return

            const ctx = canvas.getContext(`2d`)
            ctx.clearRect(0, 0, this.contentWidth, this.contentHeight)

            // 绘制背景
            ctx.fillStyle = this.randomColor(180, 240)
            ctx.fillRect(0, 0, this.contentWidth, this.contentHeight)

            // 绘制验证码文字
            for (let i = 0; i < this.currentCode.length; i++) {
                this.drawText(ctx, this.currentCode[i], i)
            }

            // 绘制干扰线
            this.drawLine(ctx)

            // 绘制干扰点
            this.drawDot(ctx)
        },

        // 绘制文字
        drawText(ctx, txt, i) {
            ctx.save()
            const x = (i + 0.5) * (this.contentWidth / this.currentCode.length)
            const y = this.contentHeight / 2

            // 随机旋转角度
            const deg = this.randomNum(-10, 10)
            ctx.translate(x, y)
            ctx.rotate(deg * Math.PI / 180)

            // 随机字体大小
            const fontSize = this.randomNum(this.fontSizeMin, this.fontSizeMax)
            ctx.font = `bold ${fontSize}px Arial`
            ctx.fillStyle = this.randomColor(50, 160)
            ctx.textBaseline = `middle`
            ctx.textAlign = `center`
            ctx.fillText(txt, 0, 0)
            ctx.restore()
        },

        // 绘制干扰线
        drawLine(ctx) {
            for (let i = 0; i < 3; i++) {
                ctx.strokeStyle = this.randomColor(100, 200)
                ctx.beginPath()
                ctx.moveTo(
                    this.randomNum(0, this.contentWidth),
                    this.randomNum(0, this.contentHeight)
                )
                ctx.lineTo(
                    this.randomNum(0, this.contentWidth),
                    this.randomNum(0, this.contentHeight)
                )
                ctx.stroke()
            }
        },

        // 绘制干扰点
        drawDot(ctx) {
            for (let i = 0; i < 30; i++) {
                ctx.fillStyle = this.randomColor(0, 255)
                ctx.beginPath()
                ctx.arc(
                    this.randomNum(0, this.contentWidth),
                    this.randomNum(0, this.contentHeight),
                    1,
                    0,
                    2 * Math.PI
                )
                ctx.fill()
            }
        }
    }
}
</script>

<style scoped>
.valid-code-container {
    height: 40px;
    display: inline-block;
    border: 1px solid #dcdfe6;
    border-radius: 4px;
    overflow: hidden;
}

.cursor-pointer {
    cursor: pointer;
}
</style>



// WEBPACK FOOTER //
// src/components/ValidCode.vue